import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const AboutSection = () => {
  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <img 
              src="https://images.unsplash.com/photo-1586685117760-ceb2c17ed8fe?w=800&q=80"
              alt="Grenew Facility"
              className="w-full aspect-[4/3] object-cover"
            />
            <div className="absolute -bottom-6 -right-6 bg-[#4fd1c5] p-8 hidden lg:block">
              <div className="text-[#0a1628]">
                <span className="text-4xl font-bold block">10+</span>
                <span className="text-sm font-semibold">Years of Excellence</span>
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            <p className="text-[#4fd1c5] text-sm font-semibold tracking-[0.15em] uppercase mb-3">
              About Grenew
            </p>
            <h2 className="text-3xl lg:text-4xl font-light text-[#0a1628] mb-6">
              We are the circular materials <span className="font-semibold">technology company</span>
            </h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              Grenew operates the UAE's most advanced e-waste recycling facility, 
              transforming electronic waste into valuable resources. With ISO-certified 
              processes and a zero-landfill commitment, we enable enterprises to meet 
              their sustainability goals while ensuring complete data security.
            </p>
            <p className="text-gray-600 leading-relaxed mb-8">
              Our state-of-the-art 150,000+ sq ft facility in Hamriyah Free Zone, Sharjah handles over 
              50,000 metric tons annually, serving Fortune 500 companies and 
              leading enterprises across the GCC region.
            </p>
            <Link 
              to="/about" 
              className="inline-flex items-center gap-2 text-[#0a1628] font-semibold hover:text-[#4fd1c5] transition-colors duration-500 ease-out"
            >
              Learn more about us
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
